import Chicago from "../assets/files/fqa/ChicagoAreaFQA.pdf";
import Louisiana from "../assets/files/fqa/CoastalLouisianaFQA.pdf";
import Colorado from "../assets/files/fqa/ColoradoFQA.pdf";
import Florida from "../assets/files/fqa/FloridaMarshes.pdf";
import FortBragg from "../assets/files/fqa/FortBraggFlora.pdf";
import Washington from "../assets/files/fqa/FQAforWashington.pdf";
import Illinois from "../assets/files/fqa/IllinoisFQA.pdf";
import KaneCounty from "../assets/files/fqa/KaneCountyNaturalAreaSurvey1978.pdf";
import Kansas from "../assets/files/fqa/KansasFQA.pdf";
import Minnesota from "../assets/files/fqa/MinnesotaRapidAssessmentManual.pdf";
import Missouri from "../assets/files/fqa/MissouriFQA.pdf";
import NERegional from "../assets/files/fqa/NERegionalFloristicQualityAssessment.pdf";
import Ohio from "../assets/files/fqa/OhioFQA.pdf";
import SouthFlorida from "../assets/files/fqa/SouthFloridaFQA.pdf";
import USACE from "../assets/files/fqa/USACEFloristicQualityAssessments.pdf";
import Wabash from "../assets/files/fqa/WabashValleyFQA.pdf";
import WestVirginia from "../assets/files/fqa/WestVirginiaWetlandFQA.pdf";
import Wisconsin from "../assets/files/fqa/WisconsinFQA.pdf";

interface EssayType {
  name: string;
  file: string;
}

export const StateFQAEssays: EssayType[] = [
  {
    name: "Chicago Area",
    file: Chicago,
  },
  {
    name: "Coastal Louisiana",
    file: Louisiana,
  },
  {
    name: "Colorado",
    file: Colorado,
  },
  {
    name: "Florida Marshes",
    file: Florida,
  },
  {
    name: "Fort Bragg",
    file: FortBragg,
  },
  {
    name: "Washington State",
    file: Washington,
  },
  {
    name: "Illinois",
    file: Illinois,
  },
  {
    name: "Kane County",
    file: KaneCounty,
  },
  {
    name: "Kansas",
    file: Kansas,
  },
  {
    name: "Minnesota",
    file: Minnesota,
  },
  {
    name: "Missouri",
    file: Missouri,
  },
  {
    name: "Northeast Regional",
    file: NERegional,
  },
  {
    name: "Ohio",
    file: Ohio,
  },
  {
    name: "South Florida",
    file: SouthFlorida,
  },
  {
    name: "USACE",
    file: USACE,
  },
  {
    name: "Wabash Valley",
    file: Wabash,
  },
  {
    name: "West Virginia",
    file: WestVirginia,
  },
  {
    name: "Wisconsin",
    file: Wisconsin,
  },
];

export default StateFQAEssays;
export type { EssayType };
